<div class="layout-row full-height viewport-area" [ngClass]="{ 'v-scroll-disabled': disabled}">
    <div class="layout-column full-width">
      <div class="layout-row rows-area">
        <div class="layout-column full-width">
          <div class="layout-row"
               *ngFor="let row of rows; index as idx;"
               [ngStyle]="{height: !disabled ? ((rowsDynamicHeights[idx] || lastCalculatedMeanRowHeight) + 'px') : 'unset'}"
          >
            <div class="layout-column full-width visible-row" #vVisibleRow
                 *ngIf="disabled || (idx >= visibleIds.firstVisibleIdx && idx <= visibleIds.lastVisibleIdx || rowsDynamicHeights[idx])"
                 [attr.data-real-idx]="idx"
            >
                <ng-container [ngTemplateOutlet]="rowTemplate" [ngTemplateOutletContext]="{row: row}"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
